/**
 * @flow
 */

import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Calendar } from '../components';

// `setOpen` is intentionally not forwarded to Calendar (matches the old
// mapProps that stripped it).
function CalendarContainer(props) {
    const locale = useSelector(({ intl }) => intl.get('locale'));
    const [isOpen, setOpen] = useState(false);

    const openPopup = useCallback(() => {
        setOpen(true);
    }, []);

    const closePopup = useCallback(() => {
        setTimeout(() => setOpen(false), 0);
    }, []);

    return (
        <Calendar
            {...props}
            locale={locale}
            isOpen={isOpen}
            openPopup={openPopup}
            closePopup={closePopup}
        />
    );
}

export default CalendarContainer;
